{
  "sidebar": {
    "home": "Home",
    "views": "Views",
    "liveTail": "Live Tail",
    "boards": "Boards",
    "screens": "Screens",
    "usage": "Usage",
    "logAnalysis": "Log Analysis",
    "logAnalysisSettings": "Log Analysis Settings",
    "logAnalysisSettingsEmpty": "Settings for log analysis will appear here.",
    "insights": "Insights",
    "logInsights": "Log Insights",
    "traceInsights": "Trace Insights",
    "metricsInsights": "Metrics Insights",
    "comingSoon": "Coming soon",
    "rehydration": "Restore",
    "settings": "Settings",
    "tools": "Tools",
    "favorites": "Favorites",
    "uncategorized": "Uncategorized",
    "pipeline": "Pipeline",
    "addToFavorites": "Add to Favorites",
    "removeFromFavorites": "Remove from Favorites"
  },
  "user": {
    "profile": "Profile",
    "preferences": "User preferences",
    "logout": "Log out"
  },
  "help": {
    "tooltip": "Help (F1)",
    "support": "Support",
    "install": "Install Instructions"
  },
  "search": {
    "tooltip": "Search"
  },
  "featureIsNotAvailableForYourPlan": "This feature is not available in your current plan"
}
